import { createFileRoute, redirect } from '@tanstack/react-router';
import { API_KEY_BASE_PATH } from '../../../features/api-auth/api-key-routing';

export const Route = createFileRoute('/_app/developer/')({
  beforeLoad: () => {
    throw redirect({ to: API_KEY_BASE_PATH });
  },
  preload: false,
});
